import type { SalesChecklistItemDefaultExample } from "@expert/contentful";

import { ChecklistExampleDefaultState } from "../ChecklistExampleDefaultState";
import { ChecklistItemExampleCarousel, type ChecklistItemExample } from "./ChecklistItemExampleCarousel";

type CarouselWithDefaultParams = {
    examples?: ChecklistItemExample[];
    defaultExample?: SalesChecklistItemDefaultExample;
};

export function CarouselWithDefault({ examples, defaultExample }: CarouselWithDefaultParams) {
    return examples?.length ? (
        <ChecklistItemExampleCarousel examples={examples} />
    ) : (
        <ChecklistExampleDefaultState {...defaultExample} />
    );
}
